import ProfilesService from "@/features/profiles/services/profiles/profileService";
import { IUser } from "@/features/profiles/services/profiles/types";

export interface ExportUsersParams {
  search?: string;
  vip?: boolean;
  subscriber?: boolean;
  isCreator?: boolean;
  createdAfter?: string;
}

const CSV_HEADERS = [
  "id",
  "email",
  "name",
  "username",
  "vip",
  "vipExpiresAt",
  "subscriptionActive",
  "subscriptionExpiresAt",
  "isCreator",
  "createdAt",
];

function escapeCsvCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (/[",\n;]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function userToRow(u: IUser): string {
  const isCreator = Boolean(u.creatorData || (u as any).isCreator);
  const cells = [
    u.id,
    u.email,
    u.name ?? u.creatorData?.name ?? "",
    u.username ?? u.creatorData?.username ?? "",
    u.vip ? "true" : "false",
    u.vipExpiresAt ?? "",
    u.subscription?.active ? "true" : "false",
    u.subscription?.expiresAt ?? "",
    isCreator ? "true" : "false",
    (u as any).createdAt ?? "",
  ];
  return cells.map(escapeCsvCell).join(",");
}

export interface ExportProgress {
  loaded: number;
  total: number;
}

export async function exportUsersToCsv(
  params: ExportUsersParams,
  onProgress?: (p: ExportProgress) => void,
): Promise<void> {
  const limit = 100;
  const maxItems = 50000;
  let page = 1;
  let total = 0;
  const allRows: string[] = [];

  // First request to discover total
  const first = await ProfilesService.Instance.getProfiles.actionBuilder({
    ...params,
    page,
    limit,
  } as any)();
  total = Math.min(first.totalItems ?? first.data.length, maxItems);
  allRows.push(...first.data.map(userToRow));
  onProgress?.({ loaded: allRows.length, total });

  const totalPages = Math.min(first.totalPage ?? 1, Math.ceil(maxItems / limit));
  for (page = 2; page <= totalPages; page++) {
    const resp = await ProfilesService.Instance.getProfiles.actionBuilder({
      ...params,
      page,
      limit,
    } as any)();
    allRows.push(...resp.data.map(userToRow));
    onProgress?.({ loaded: allRows.length, total });
    if (allRows.length >= maxItems) break;
  }

  const csv = "\uFEFF" + [CSV_HEADERS.join(","), ...allRows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const today = new Date().toISOString().slice(0, 10);
  const a = document.createElement("a");
  a.href = url;
  a.download = `usuarios_${today}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
